import { Plane, Phone, Building2, Smartphone } from "lucide-react";
import { COMPANY } from "@/data/content";
import { BrandWord } from "@/components/BrandWord";

export function Footer() {
  return (
    <footer id="contact" className="border-t border-white/10 bg-brand-surface/40 grain">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-full bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center">
              <Plane className="w-4 h-4 text-brand-gold" />
            </span>
            <BrandWord className="text-lg" />
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            {COMPANY.name}. Trusted travel & visa specialists helping you explore the world with confidence.
          </p>
        </div>

        <div>
          <h4 className="font-display text-brand-gold mb-4 text-lg">Reach Us</h4>
          <a href={`https://wa.me/${COMPANY.whatsappIntl}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white/70 hover:text-brand-gold transition-colors mb-3">
            <Phone className="w-4 h-4" /> WhatsApp: {COMPANY.whatsapp}
          </a>
          <a href={`https://wa.me/${COMPANY.whatsapp2Intl}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-2" className="flex items-center gap-3 text-white/70 hover:text-brand-gold transition-colors mb-3">
            <Phone className="w-4 h-4" /> WhatsApp: {COMPANY.whatsapp2}
          </a>
          <p className="text-white/50 text-sm">Owners: {COMPANY.owners.join(" & ")}</p>
        </div>

        <div>
          <h4 className="font-display text-brand-gold mb-4 text-lg">Payment Details</h4>
          <div className="flex items-start gap-3 text-white/70 text-sm mb-3">
            <Smartphone className="w-4 h-4 mt-0.5 text-brand-gold" />
            <span>Mobile Money<br /><span className="text-brand-text font-medium">{COMPANY.momo}</span></span>
          </div>
          {COMPANY.banks.map((b) => (
            <div key={b.account} className="flex items-start gap-3 text-white/70 text-sm mb-3">
              <Building2 className="w-4 h-4 mt-0.5 text-brand-gold" />
              <span>{b.name}<br /><span className="text-brand-text font-medium">{b.account}</span></span>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-xs">
        © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
      </div>
    </footer>
  );
}
